import React, { useContext, useRef, memo, useEffect } from 'react';
import Input from './AddComment';

import CommentListCtx from './CommentListCtx';
import Comment from './Comment';
// import { useComment } from '@components/CommentCenter';
const ThreadCard = ({
  comments = [],
  idx,
  showModuleInTag,
  getInnerTooltipPopupContainer,
  showTag,
  commentListType,
  ...restProp
}) => {
  const { scrollList, activeInput, handleActiveInput } =
    useContext(CommentListCtx);

  // const { inputIdxs } = useContext(CommentListCtx);
  const threadRef = useRef();
  const inputRef = useRef();

  useEffect(() => {
    if (activeInput[0] === idx) {
      inputRef.current.setShow(true);
    } else {
      inputRef.current.setShow(false);
    }
  }, [activeInput]);

  const handleShowAdd = (e, state) => {
    // if (e?.target?.className?.includes('genesis')) {
    // setShow(true);

    if (restProp.channelStatus) {
      return;
    } // resolved comment should not show input
    const show = inputRef.current.getShowStatus();
    if (!show) {
      // inputRef.current.setShow(true);
      handleActiveInput(idx);
    }

    scrollList({
      ref: threadRef,
      type: ['offsetHeight', 'offsetTop'],
      delay: show ? false : true,
    });
    // }
  };

  // useEffect(() => {
  //   const loc = inputIdxs.findIndex((item) => item === idx);
  //   debugger;
  // }, [inputIdxs]);

  const handleScroll = () => {
    scrollList({
      ref: threadRef,
      type: 'offsetTop',
    });
  };

  const channelId = (restProp || comments?.[0])?.channel;
  return (
    <div
      className="comment-thread"
      ref={threadRef}
      key={idx}
      data-comment-channel={channelId}
    >
      {[{ ...restProp }, ...comments].map((comment, i) => (
        <Comment
          key={i}
          idx={idx}
          isGenesis={i === 0}
          showModuleInTag={showModuleInTag}
          showTag={showTag}
          commentIdx={i}
          handleShowAdd={handleShowAdd}
          commentListType={commentListType}
          {...comment}
          getInnerTooltipPopupContainer={getInnerTooltipPopupContainer}
          threadStatus={restProp.channelStatus}
        />
      ))}
      <Input
        ref={inputRef}
        threadIdx={idx}
        scrollToThreadTop={handleScroll}
        key={idx}
        {...restProp}
      />
    </div>
  );
};
export default memo(ThreadCard);
